export default "__VITE_ASSET__Dv5FXevi__"